/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import {
  disableUseNative,
  enableUseNative,
  shouldUseNative,
} from '../../../lib/nativeUsageStore';
import { Checkbox, CheckboxProps } from '@getgo/chameleon-chakra-ui';

const messages = defineMessages({
  ariaAutoJoin: {
    id: 'util.ariaAlwaysAutoJoin',
  },
});

interface Props extends CheckboxProps {
  ariaDescribedByLabel: string;
}

export const AlwaysUseNativeCheckbox: React.FC<Props> = ({
  ariaDescribedByLabel,
  ...props
}) => {
  const { formatMessage: f } = useIntl();
  const [
    isAlwaysUseNativeCheckboxChecked,
    setIsAlwaysUseNativeCheckboxChecked,
  ] = useState(shouldUseNative());

  const toggleAlwaysUseNative = () => {
    isAlwaysUseNativeCheckboxChecked ? disableUseNative() : enableUseNative();
    setIsAlwaysUseNativeCheckboxChecked(!isAlwaysUseNativeCheckboxChecked);
  };
  return (
    <Checkbox
      name='alwaysUseNativeCheckbox'
      value='autoJoin'
      aria-label={f(messages.ariaAutoJoin)}
      aria-describedby={ariaDescribedByLabel}
      isChecked={isAlwaysUseNativeCheckboxChecked}
      onChange={toggleAlwaysUseNative}
      mr={2}
      {...props}
    />
  );
};
